import React from 'react';
import './index.css';
import Toast from '../common/Toast'
import util from "../../util/tools";
import commonTools from "../../../common/util/util";
import { Link } from "react-router-dom";
import Header from "../common/Header";
import Activity from '../common/activity'
import ActivityPopup from '../common/ActivityPopup'

const newCustomData = [
    {
        give_coin: 666,
        pay_coin: 2880,
        total_fee: 2880,
        sign: '1234',
        type: "1"
    },
    {
        give_coin: 1888,
        pay_coin: 5000,
        total_fee: 5000,
        sign: '1234',
        type: "1"
    },
    {
        give_coin: 3888,
        pay_coin: 10000,
        total_fee: 10000,
        sign: '1234',
        type: "1"
    },
    {
        give_coin: 8888,
        pay_coin: 19880,
        total_fee: 19880,
        sign: '1234',
        type: "1"
    },
    {
        give_coin: 18888,
        pay_coin: 30000,
        total_fee: 30000,
        sign: '1234',
        type: "1"
    },
    {
        give_coin: 58888,
        pay_coin: 50000,
        total_fee: 50000,
        sign: '1234',
        type: "1"
    },
]

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            weixinurl: "",
            bookId: "",
            hongbao:'',
            coin:'',
            text:'',
            imgs: [],
            cur: 0,
            cur1: 1,
            hms: true,
            doubleOneStart: false, // 双十一活动
            yuandanStart: false, // 元旦活动
            activeData: {
                img_url: "",
                link_url: "",
                only_home: 1
            },
            activeCoin: {
                is_open:0,
                total_fee:'0',
                coin: 0
            },
            newActiveCoin: {
                new_chongzhi_status: 0,//新版充值档是否开启（1标识开启，0标识未开启）
                redeploy: [
                    // {
                    //     type: 1,//支付类型1.充值送金币2.充值送会员
                    //     is_first_pay: 1,//是否首充
                    //     total_fee: 999,//充值金额（单位分）
                    //     pay_coin: 999,//（充值对应金币）
                    //     give_coin: 0,//（充值对应赠币）
                    //     first_pay_give_coin: 0,//（首充对应赠币）
                    //     remarks: "",//（标注，会员充值档可用里面的内容）
                    //     sign: 1 //（充值是传递的参数，1充值的时候传入firstpay=1，2充值的时候传入newpay=1）
                    // }
                ]
            },
            isFirst: true, // 是否是首充
            isVip: true, // 是否是vip
            isAdd: true, // 是否有赠币
            ishongbao: true, // 是否是红包
            showPopup: false,
            popupId: null,
            activityUrl: '',
            activityId: '',
            newCustomData
        };
    }
    getActiveInfo(){
        util.ajax({
            url: "/zh/additional/acitve",
            data:{
                only_home: 0
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    console.log('活动数据',json);
                    this.setState({activeData: json})
                }
            }
        });
    }
    getNewActiveCoin(){
        console.log('}}}}');
        util.ajax({
            url: "/zh/pay/redeploy",
            isUser: true,
            data: {},
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data;
                    console.log('新充值数据',data);
                    this.setState({
                        newActiveCoin: data
                    })
                }
            }
        });
    }
    componentDidMount() {
        document.title = '金币充值'
        this.getActiveInfo();
        this.getActiveCoin();
        this.getNewActiveCoin();
        this.checkPopup()
        this.setState({
            // hms: !!commonTools.searchPar().hms,
            bookId: this.props.match.params.bookId,
            weixinurl: this.props.match.params.weixinurl
        },()=>{
            this.getUserInfo();
            if(!!this.state.hms){
                util.ajax({
                    url: "/zh/sendgift/goodsbanner",
                    callback: res => {
                        if (res.result.status.code == 0) {
                            let imgs = [];
                            for(let item in res.result.data){
                                imgs.push({
                                    val: item,
                                    src: res.result.data[item]
                                });
                            }
                            this.setState({
                                imgs: imgs
                            },()=>{
                                try{
                                    window.dispatchEvent(new Event('resize'));
                                }catch(e){}
                            })
                        }
                    }
                });
            }
        });
        let minTime4 = new Date("2019/11/11 00:00:00").getTime();
        let maxTime4 = new Date("2019/11/14 00:00:00").getTime();
        let curTime = new Date().getTime();
        if((curTime >= minTime4 && curTime <= maxTime4) || !!commonTools.searchPar().doubleOneStart){
            this.setState({
                doubleOneStart: true
            });
        }
        let minTime5 = new Date("2019/12/31 19:00:00").getTime();
        let maxTime5 = new Date("2020/01/4 23:59:00").getTime();
        if((curTime >= minTime5 && curTime <= maxTime5) || !!commonTools.searchPar().yuandanStart){
            this.setState({
                yuandanStart: true
            });
        }
    }

    componentWillUnmount(){
        clearInterval(this.timer1);
    }

    getUserInfo(){
        util.ajax({
            url: "/zh/user/userInfo",
            isUser: true,
            data: {},
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data
                    this.setState({
                        coin:data.user_money.coin,
                        hongbao:data.user_money.hongbao
                    })
                }
            }
        });
    }

    getActiveCoin(){
        util.ajax({
            url: "/zh/paymanage/info",
            isUser: true,
            data: {},
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data;
                    console.log('充值数据',data);
                    this.setState({
                        activeCoin: data
                    })
                }
            }
        });
    }

    showText(text){
        this.setState({
            text:text
        },()=>{
            setTimeout(()=>{
                this.setState({
                    text:"",
                })
            },2000)
        })
    }

    recharge(item,jump,isfixed){
        let url = this.state.weixinurl || `${document.location.href}`;
        let url1 = "";
        if(!!jump){
            url1 = document.location.origin + "/wuliulist";
        }
        let params = {
            'total_fee': isfixed ? item : item*10*10,
            'back_url':url1 || url,
            'error_url':url,
            'type': commonTools.searchPar().type,
            'treasure':commonTools.searchPar().treasure,
            'bookpack_id': commonTools.searchPar().bookpack_id
        }
        if(isfixed == 1){
            params.firstpay = 1;
        }
        if(isfixed == 2){
            params.newpay = 1;
        }
        console.log('8888',params);
        if(!commonTools.searchPar().type){
            delete params.type
        }
        if(!!this.state.bookId){
            params.book_id = this.state.bookId
        }
        util.ajax({
            url: "/zh/pay/wgpay",
            method:'post',
            isUser: true,
            isWechatId: true,
            data: params,
            callback: res => {
                if (res.result.status.code == 0) {
                    document.location.href = res.result.data.url
                }else {
                    this.showText(res.result.status.msg);
                }
            }
        });
    }

    goRoute(url){
        this.props.history.push(url || '/balance')
    }

    // 判断是否有活动弹窗
    checkPopup() {
        const date = new Date()
        const fullYear = date.getFullYear()
        const month = date.getMonth()
        const day = date.getDate()
        const fullDate = `${fullYear}-${month+1}-${day}`
        const oldDate = localStorage.popupDate3
        util.ajax({
            url: '/zh/activity/activitypopup',
            data:{
                popup_id: 3
            },
            callback: res => {
                // console.log(res)
                if (res.result.status.code == 0 && res.result.data.length) {
                    const data = res.result.data[0]
                    this.setState({
                        popupId: data.temp_id,
                        activityUrl: data.activity_url,
                        activityId: data.id
                    })
                    if (!oldDate) {
                        this.setState({
                            showPopup: true
                        })
                        localStorage.popupDate3 = fullDate
                    } else if (oldDate && fullDate != oldDate ) {
                        this.setState({
                            showPopup: true
                        })
                        localStorage.popupDate3 = fullDate
                    } else {
                        this.setState({
                            showPopup: false
                        })
                    }
                }
            }
        })
    }

    // 关闭弹窗
    closePopup = () => {
        this.setState({
            showPopup: false
        })
    }

    render() {
        var isNew = this.state.newActiveCoin.new_chongzhi_status;
        var newData = this.state.newActiveCoin.redeploy;
        console.log('newData: ', newData)
        return (
            <div className='recharge'>
                <Header />
                {
                    // !!this.state.hms && this.state.imgs.length > 0 &&
                    // <div className='bannerBox'>
                    //     <WingBlank>
                    //         <Carousel
                    //             selectedIndex={0}
                    //             dots={false}
                    //             autoplay={true}
                    //             autoplayInterval={2000}
                    //             infinite={true}
                    //         >
                    //         {
                    //             this.state.imgs.map((item,index) => (
                    //                 <img className={`${index == this.state.cur?"active":""} ${index == this.state.cur1?"nextImg":""}`} onClick={()=>this.goRoute("/libao/"+item.val)} src={item.src} key={`bannerimg${index}`} />
                    //             ))
                    //         }
                    //         </Carousel>
                    //     </WingBlank>
                    // </div>
                }
                <div className='header'>
                    <div className='header_top'>
                        <span className='header_money_num' key='1'>{this.state.coin || 0}</span>
                        <span className='header_money_font' key='2'> 金币</span>
                        {
                            !!this.state.hongbao &&
                                [
                                    <span className='header_money_num' key='3'>+{this.state.hongbao}</span>,
                                    <span className='header_money_font' key='4'> 红包</span>
                                ]
                        }
                    </div>
                    <div className='header_btm'>
                        <a className='look_btn' onClick={()=>this.goRoute()}>查看余额详情</a>
                    </div>
                </div>
                <div className='intro'>
                    <span>充值赠送的红包有效期为5天，过期自动失效；消费时优先扣除距离过期时间最近的红包。</span>

                </div>
                {/* 公共活动 */}
                <Activity location="recharge" notStyle={false}/>
                {
                    !!this.state.doubleOneStart &&
                    <Link to='/dubleonecharge'><img className="dubleoneImg" src={require("../../../common/images/dubleBg.jpg")} /></Link>
                }
                {
                    !!this.state.yuandanStart &&
                    <Link to='/activeFirstDayForYear?from=2'><img className="dubleoneImg" src={require("../../../common/images/yuandanmin.jpg")} /></Link>
                }
                {/*活动*/}
                {
                    this.state.activeData.img_url && this.state.activeData.only_home === 0 &&
                    <Link to={this.state.activeData.link_url + '?from=2'}><img className="dubleoneImg" src={this.state.activeData.img_url} /></Link>
                }
                <div className='recharge'>
                    <div className='recharge_header'>
                        <div className='recharge_header_line'>
                        </div>
                        <span className='recharge_header_money'>请选择充值金额</span>
                        <span className='recharge_header_moneyColor'>（100金币/红包=1元）</span>
                    </div>
                    <div className='recharge_items'>
                        <a style={{display: ((this.state.activeCoin.is_open == 1)&&!(isNew == 1)) ? 'block' : 'none'}} className='block newBox' onClick={()=>this.recharge(this.state.activeCoin.total_fee,null,1)}>
                            <div className="newBox_top">得{this.state.activeCoin.coin}金币</div>
                            <div className="newBox_middle">
                                <span>{this.state.activeCoin.coin}金币</span>
                                {/*<img src={require('../../../common/images/addhb.png')} alt=""/>*/}
                                {/*<span className="subCoin">10010</span>*/}
                            </div>
                            <div className="newBox_bottom">￥{(Number(this.state.activeCoin.total_fee)/100).toFixed(2)}</div>
                            {/*<img  src={require(`../../../common/images/1_1.png`)} />*/}
                        </a>
                        {/*<ChargeCard weixinurl={this.state.weixinurl}/>*/}
                        {/*首冲*/}
                        {
                            isNew == 1&&newData.map((item,index)=>{
                                return <a key={index} style={{display: 'block'}} className={item.type == 2  ? 'block newBox vipcharge' : item.type == 1&&item.is_first_pay == 1 ? 'block newBox firstCharge' : 'block newBox'} onClick={()=>this.recharge(item.total_fee,null,item.sign)}>
                                    <div style={{color: item.type == 2 ? 'rgba(121, 81, 0, 1)' : '#333'}} className="newBox_top">
                                        {
                                            item.type == 2 ? '包年VIP' :  '得' + (item.pay_coin + (item.is_first_pay == 1 ? item.first_pay_give_coin : item.give_coin)) + '金币'
                                        }
                                    </div>
                                    <div style={{color: item.type == 2 ? 'rgba(121, 81, 0, 1)' : '#333'}} className="newBox_middle">
                                        <span>{item.type == 2 ? item.remarks : item.pay_coin + '金币'}</span>
                                        {
                                            (item.first_pay_give_coin !== 0||item.give_coin !== 0)&&<span className="subCoin isSubadd" style={{color: 'rgba(237,100,96,1)'}}>
                                                    {
                                                        item.is_first_pay == 1 ? item.first_pay_give_coin : item.give_coin
                                                    }金币
                                                </span>
                                        }
                                        </div>
                                    <div style={{color: item.type == 2 ? 'rgba(121, 81, 0, 1)' : '#333'}} className="newBox_bottom">
                                            <span className="valid" style={{color: item.type == 2 ? 'rgba(121, 81, 0, 1)' : 'rgba(237,100,96,1)'}}>
                                                ￥{(Number(item.total_fee)/100).toFixed(2)}
                                            </span>
                                            {
                                                item.is_first_pay == 1&&item.sign == 2&&
                                                <span className="notvalid">
                                                    ￥{(Number(item.total_fee)*2/100).toFixed(2)}
                                                </span>
                                            }

                                    </div>
                                </a>
                            })
                        }
                        {
                            !isNew&&newCustomData.map((item,index)=>{
                                return <a key={index} style={{display: 'block'}} className={item.type == 1&&item.is_first_pay == 1 ? 'block newBox firstCharge' : 'block newBox'} onClick={()=>this.recharge(item.total_fee, null, item.sign)}>
                                    <div style={{color: '#333'}} className="newBox_top">
                                        {
                                            '得' + (item.pay_coin + item.give_coin) + '金币'
                                        }
                                    </div>
                                    <div style={{color: '#333'}} className="newBox_middle">
                                        <span>{item.pay_coin + '金币'}</span>
                                        {
                                            (item.give_coin !== 0 ) && 
                                                <span className="subCoin isSubadd" style={{color: 'rgba(237,100,96,1)'}}>
                                                    {item.give_coin}金币
                                                </span>
                                        }
                                        </div>
                                    <div style={{color: '#333'}} className="newBox_bottom">
                                        <span className="valid" style={{color: 'rgba(237,100,96,1)'}}>
                                            ￥{(Number(item.total_fee)/100).toFixed(2)}
                                        </span>
                                    </div>
                                </a>
                            })
                        }
                        {
                            /* isNew&&[29.9,49.9,99.9,199.9].map((item,index)=>{
                                return (
                                    <a className='block' onClick={()=>this.recharge(item)} key={`r${index}`}>
                                        <img  src={require(`../../../common/images/${index+1}_1.png`)} />
                                    </a>
                                )
                            }) */
                        }
                    </div>
                    {
                        // !!this.state.hms &&
                        // <div className='recharge_header'>
                        //     <div className='recharge_header_line'>
                        //     </div>
                        //     <span className='recharge_header_money'>更多超值礼包</span>
                        // </div>
                    }
                    {
                        // !!this.state.hms &&
                        // <div className='libaoItems clearfix'>
                        //     {[198,298,398].map((item,index)=>{
                        //         return (
                        //             <div className='block' key={`lb${index}`}>
                        //                 <img  src={require(`../../../common/images/lb${index+1}.png`)} />
                        //                 <div className="payBtn" onClick={()=>this.recharge(item,1)}></div>
                        //                 <div className="lookBtn" onClick={()=>this.goRoute("/libao/"+item*10*10)}></div>
                        //             </div>
                        //         )
                        //     })}
                        // </div>
                    }
                    <span className='recharge_xuni'>*虚拟商品购买不可退换</span>
                </div>
                <Toast text={this.state.text}/>
                {
                    this.state.showPopup &&
                    <ActivityPopup
                        popupId={this.state.popupId} activityUrl={this.state.activityUrl}
                        activityId={this.state.activityId} closePopup={this.closePopup}>
                    </ActivityPopup>
                }
            </div>
        );
    }
}